import React, { useRef, useEffect, useState } from 'react';
import styled, { keyframes, css } from 'styled-components';
import PropTypes from 'prop-types';

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 20px;
  background-color: #f0f0f0;
  border-radius: 10px;
`;

const fillWidth = keyframes`
  0% {
    width: 0%;
    opacity: 0;
  }
  100% {
    opacity: 1;
    width: ${({ percentage }) => percentage}%;
  }
`;

const ProgressFill = styled.div`
  height: 100%;
  opacity: 0;
  border-radius: 10px;
  background-color: ${({ percentage }) => {
    if (percentage > 80) {
      return '#88ff00';
    }
    if (percentage > 60) {
      return '#007bff';
    }
    if (percentage > 40) {
      return '#ffd500';
    }
    return '#ff0000';
  }};
  ${({ percentage }) =>
    css`
      animation: ${fillWidth} 3s ease-in-out forwards;
      animation-timing-function: ease-in-out;
      width: ${percentage}%;
      animation-delay: 0s;
      opacity: 0;
    `}
`;

function ProgressBar({ percentage }) {
  const progressBarRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (progressBarRef.current) {
      observer.observe(progressBarRef.current);
    }

    return () => {
      if (progressBarRef.current) {
        observer.unobserve(progressBarRef.current);
      }
    };
  }, [progressBarRef]);

  return (
    <ProgressBarContainer ref={progressBarRef}>
      {isVisible && <ProgressFill percentage={percentage} />}
    </ProgressBarContainer>
  );
}

export default ProgressBar;

ProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
};
